import { showBanner } from './../template/template.js'
import './style.min.css'
import { gsap } from 'gsap'
import { sha256 } from 'js-sha256'

const isFR = document.documentElement.lang == 'fr'

/* -------- START PRODUCTS & CART -------- */
const STOCK_POST_URL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdU73QeEuysBfwbka1lzZbccGMy-75GA86XJzyBfLUf_KqOdQ/formResponse'
const ORDER_POST_URL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSc8Ag0FIYqBCR5TMKOhXUP5z3TvGO9UvJ9pSrtZ1nKf0D5B4g/formResponse'
const ORDER_FORM = {
    orderID: 'entry.1838627875',
    name: 'entry.1884265043',
    email: 'entry.941499488',
    reminders: 'entry.1384152725',
    order: 'entry.1212348438',
    delivery: 'entry.513669972',
    referrer: 'entry.869293977',
}
const PAYMENT_POST_URL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScxGGGuIs6DR3xwq82QZ7oH6jdNA_I1g6-7sL20HV3_5kxVMw/formResponse'
const PAYMENT_FORM = 'entry.1212348438'
const PRODUCTS = [
    {
        name: 'Black Coda X Power Lab Tee',
        nameFR: 'T-shirt Coda X Power Lab noir',
        description:
            "Don't miss out on this exciting collab! This tee will have you looking fresh in the gym while supporting our annual Ribbon Campaign. Tip: go one or two sizes up for a trendy oversized look! <br/><br/>Join us in making a difference. All proceeds will go towards supporting Coda's future events and projects for cancer patients everywhere.",
        descriptionFR:
            'Ne manquez pas cette excitante collaboration! Ce t-shirt est parfait pour le gym et montre votre soutien pour notre Campagne annuelle du ruban. <br/><br/>Rejoignez-nous pour faire la différence. Tous les bénéfices seront dédiés à soutenir les futurs événements et projets de Coda pour les patients atteints de cancer.',
        price: 22,
        sizes: ['s', 'm', 'l', 'xl', '2xl', '3xl'],
        sizingGuide: 'tee-sizing-guide.jpg',
        folder: '2024-ribbon-campaign',
        thumbnail: 'black-tee.jpg',
        containThumbnail: '#ffffff',
        images: [
            ['black-1.jpg', '', '#000000'],
            ['black-2.jpg', '', '#000000'],
            ['black-3.jpg', '', '#000000'],
            ['black-4.jpg', '', '#000000'],
            ['black-5.jpg', '', '#000000'],
            ['black-tee.jpg', '', '#ffffff'],
            ['black-tee-back.jpg', '', '#ffffff'],
        ],
        imagesFR: [
            ['black-1.jpg', '', '#000000'],
            ['black-2.jpg', '', '#000000'],
            ['black-3.jpg', '', '#000000'],
            ['black-4.jpg', '', '#000000'],
            ['black-5.jpg', '', '#000000'],
            ['black-tee.jpg', '', '#ffffff'],
            ['black-tee-back.jpg', '', '#ffffff'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'White Coda X Power Lab Tee',
        nameFR: 'T-shirt Coda X Power Lab blanc',
        description:
            "Don't miss out on this exciting collab! This tee will have you looking fresh in the gym while supporting our annual Ribbon Campaign. Tip: go one or two sizes up for a trendy oversized look! <br/><br/>Join us in making a difference. All proceeds will go towards supporting Coda's future events and projects for cancer patients everywhere.",
        descriptionFR:
            'Ne manquez pas cette excitante collaboration! Ce t-shirt est parfait pour le gym et montre votre soutien pour notre Campagne annuelle du ruban. <br/><br/>Rejoignez-nous pour faire la différence. Tous les bénéfices seront dédiés à soutenir les futurs événements et projets de Coda pour les patients atteints de cancer.',
        price: 22,
        sizes: ['s', 'm', 'l', 'xl', '2xl', '3xl'],
        sizingGuide: 'tee-sizing-guide.jpg',
        folder: '2024-ribbon-campaign',
        thumbnail: 'white-tee.jpg',
        containThumbnail: '#000000',
        images: [
            ['white-1.jpg', '', '#000000'],
            ['white-2.jpg', '', '#000000'],
            ['white-3.jpg', '', '#000000'],
            ['white-tee.jpg', '', '#000000'],
            ['white-tee-back.jpg', '', '#000000'],
        ],
        imagesFR: [
            ['white-1.jpg', '', '#000000'],
            ['white-2.jpg', '', '#000000'],
            ['white-3.jpg', '', '#000000'],
            ['white-tee.jpg', '', '#000000'],
            ['white-tee-back.jpg', '', '#000000'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'Burgundy Crewneck',
        nameFR: 'Crewneck bourgogne',
        description:
            "Elevate your style while supporting our annual Ribbon Campaign with our exclusive line of crewneck sweaters! Crafted with care and attention to detail, these crewnecks offer comfort and style, all while making a meaningful statement. <br/><br/>Join us in making a difference. All proceeds will go towards supporting Coda's future events and projects for cancer patients everywhere.",
        descriptionFR:
            'Élevez votre style tout en soutenant notre Campagne annuelle du ruban avec notre collection exclusive de crewnecks! Fabriqués avec soin et souci du détail, ces crewnecks offrent confort et style, tout en véhiculant un message significatif. <br/><br/>Rejoignez-nous pour faire la différence. Tous les bénéfices seront dédiés à soutenir les futurs événements et projets de Coda pour les patients atteints de cancer.',
        price: 30,
        sizes: ['s', 'm', 'l', 'xl', '2xl'],
        sizingGuide: 'sizing-guide.jpg',
        folder: '2024-ribbon-campaign',
        thumbnail: 'garnet.jpg',
        containThumbnail: '#ffffff',
        images: [
            ['garnet-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['garnet.jpg', '', '#ffffff'],
            ['garnet-back.jpg', '', '#ffffff'],
        ],
        imagesFR: [
            ['garnet-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['garnet.jpg', '', '#ffffff'],
            ['garnet-back.jpg', '', '#ffffff'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'Light Blue Crewneck',
        nameFR: 'Crewneck bleu ciel',
        description:
            "Elevate your style while supporting our annual Ribbon Campaign with our exclusive line of crewneck sweaters! Crafted with care and attention to detail, these crewnecks offer comfort and style, all while making a meaningful statement. <br/><br/>Join us in making a difference. All proceeds will go towards supporting Coda's future events and projects for cancer patients everywhere.",
        descriptionFR:
            'Élevez votre style tout en soutenant notre Campagne annuelle du ruban avec notre collection exclusive de crewnecks! Fabriqués avec soin et souci du détail, ces crewnecks offrent confort et style, tout en véhiculant un message significatif. <br/><br/>Rejoignez-nous pour faire la différence. Tous les bénéfices seront dédiés à soutenir les futurs événements et projets de Coda pour les patients atteints de cancer.',
        price: 30,
        sizes: ['s', 'm', 'l', 'xl', '2xl'],
        sizingGuide: 'sizing-guide.jpg',
        folder: '2024-ribbon-campaign',
        thumbnail: 'carolina-blue.jpg',
        containThumbnail: '#ffffff',
        images: [
            ['carolina-blue-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['carolina-blue.jpg', '', '#ffffff'],
            ['carolina-blue-back.jpg', '', '#ffffff'],
        ],
        imagesFR: [
            ['carolina-blue-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['carolina-blue.jpg', '', '#ffffff'],
            ['carolina-blue-back.jpg', '', '#ffffff'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'Navy Crewneck',
        nameFR: 'Crewneck bleu marine',
        description:
            "Elevate your style while supporting our annual Ribbon Campaign with our exclusive line of crewneck sweaters! Crafted with care and attention to detail, these crewnecks offer comfort and style, all while making a meaningful statement. <br/><br/>Join us in making a difference. All proceeds will go towards supporting Coda's future events and projects for cancer patients everywhere.",
        descriptionFR:
            'Élevez votre style tout en soutenant notre Campagne annuelle du ruban avec notre collection exclusive de crewnecks! Fabriqués avec soin et souci du détail, ces crewnecks offrent confort et style, tout en véhiculant un message significatif. <br/><br/>Rejoignez-nous pour faire la différence. Tous les bénéfices seront dédiés à soutenir les futurs événements et projets de Coda pour les patients atteints de cancer.',
        price: 30,
        sizes: ['s', 'm', 'l', 'xl', '2xl'],
        sizingGuide: 'sizing-guide.jpg',
        folder: '2024-ribbon-campaign',
        thumbnail: 'navy.jpg',
        containThumbnail: '#ffffff',
        images: [
            ['navy-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['navy.jpg', '', '#ffffff'],
            ['navy-back.jpg', '', '#ffffff'],
        ],
        imagesFR: [
            ['navy-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['navy.jpg', '', '#ffffff'],
            ['navy-back.jpg', '', '#ffffff'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'Green Crewneck',
        nameFR: 'Crewneck vert',
        description:
            "Elevate your style while supporting our annual Ribbon Campaign with our exclusive line of crewneck sweaters! Crafted with care and attention to detail, these crewnecks offer comfort and style, all while making a meaningful statement. <br/><br/>Join us in making a difference. All proceeds will go towards supporting Coda's future events and projects for cancer patients everywhere.",
        descriptionFR:
            'Élevez votre style tout en soutenant notre Campagne annuelle du ruban avec notre collection exclusive de crewnecks! Fabriqués avec soin et souci du détail, ces crewnecks offrent confort et style, tout en véhiculant un message significatif. <br/><br/>Rejoignez-nous pour faire la différence. Tous les bénéfices seront dédiés à soutenir les futurs événements et projets de Coda pour les patients atteints de cancer.',
        price: 30,
        sizes: ['s', 'm', 'l', 'xl', '2xl'],
        sizingGuide: 'sizing-guide.jpg',
        folder: '2024-ribbon-campaign',
        thumbnail: 'heather-dark-green.jpg',
        containThumbnail: '#ffffff',
        images: [
            ['heather-dark-green-model.jpg', '', '#000000'],
            ['dark-chocolate-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['heather-dark-green.jpg', '', '#ffffff'],
            ['heather-dark-green-back.jpg', '', '#ffffff'],
        ],
        imagesFR: [
            ['heather-dark-green-model.jpg', '', '#000000'],
            ['dark-chocolate-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['heather-dark-green.jpg', '', '#ffffff'],
            ['heather-dark-green-back.jpg', '', '#ffffff'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'Brown Crewneck',
        nameFR: 'Crewneck brun',
        description:
            "Elevate your style while supporting our annual Ribbon Campaign with our exclusive line of crewneck sweaters! Crafted with care and attention to detail, these crewnecks offer comfort and style, all while making a meaningful statement. <br/><br/>Join us in making a difference. All proceeds will go towards supporting Coda's future events and projects for cancer patients everywhere.",
        descriptionFR:
            'Élevez votre style tout en soutenant notre Campagne annuelle du ruban avec notre collection exclusive de crewnecks! Fabriqués avec soin et souci du détail, ces crewnecks offrent confort et style, tout en véhiculant un message significatif. <br/><br/>Rejoignez-nous pour faire la différence. Tous les bénéfices seront dédiés à soutenir les futurs événements et projets de Coda pour les patients atteints de cancer.',
        price: 30,
        sizes: ['s', 'm', 'l', 'xl', '2xl'],
        sizingGuide: 'sizing-guide.jpg',
        folder: '2024-ribbon-campaign',
        thumbnail: 'dark-chocolate.jpg',
        containThumbnail: '#ffffff',
        images: [
            ['dark-chocolate-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['dark-chocolate.jpg', '', '#ffffff'],
            ['dark-chocolate-back.jpg', '', '#ffffff'],
        ],
        imagesFR: [
            ['dark-chocolate-model.jpg', '', '#000000'],
            ['all.jpg', '', '#000000'],
            ['dark-chocolate.jpg', '', '#ffffff'],
            ['dark-chocolate-back.jpg', '', '#ffffff'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'Coda Gala',
        nameFR: 'Gala Coda',
        description:
            'Join us on Saturday, February 3rd at the Coda Gala at Prima Luna Reception Hall to celebrate World Cancer Day. Enjoy a 5-course meal where all proceeds go to the Quebec Cancer Foundation. Together, we will Shine a Light on Cancer 🌟🎗️',
        descriptionFR:
            "Rejoignez-nous samedi le 3 février pour le Gala Coda au Hall de réception Prima Luna pour célébrer la Journée mondiale contre le cancer. Dégustez la table d'hôte en 5 services au bénéfice de la Fondation québécoise du cancer. Ensemble, illuminons la lutte contre le cancer 🌟🎗️",
        price: 150,
        noTag: true,
        folder: '2024-world-cancer-day',
        thumbnail: 'post.jpg',
        images: [
            ['details.png', '', '#000000'],
            ['post.jpg', '', '#000000'],
        ],
        imagesFR: [
            ['details-fr.png', '', '#000000'],
            ['post.jpg', '', '#000000'],
        ],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    // {
    //     name: 'Table Discount',
    //     nameFR: 'Réserver une table',
    //     description:
    //         'Save money by reserving an entire table! Each table seats a maximum of 10 people. <br/><br/>Join us on Saturday, February 3rd at the Coda Gala at Prima Luna Reception Hall to celebrate World Cancer Day. Enjoy a 5-course meal where all proceeds go to the Quebec Cancer Foundation. <b>Main course selection will be made by email.</b> Together, we will Shine a Light on Cancer 🌟🎗️',
    //     descriptionFR:
    //         "Économisez en réservant une table entière! Chaque table accueille un maximum de 10 personnes. <br/><br/>Rejoignez-nous samedi le 3 février pour le Gala Coda au Hall de réception Prima Luna pour célébrer la Journée mondiale contre le cancer. Dégustez la table d'hôte en 5 services au bénéfice de la Fondation québécoise du cancer. <b>Le choix du plat principal se fera par courriel.</b> Ensemble, illuminons la lutte contre le cancer 🌟🎗️",
    //     price: 1400,
    //     noTag: true,
    //     folder: '2024-world-cancer-day',
    //     thumbnail: 'table.jpg',
    //     thumbnailFR: 'table-fr.jpg',
    //     images: [
    //         ['details.png', '', '#000000'],
    //         ['table.jpg', '', '#000000'],
    //     ],
    //     imagesFR: [
    //         ['details-fr.png', '', '#000000'],
    //         ['table-fr.jpg', '', '#000000'],
    //     ],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1pH6F4upd3FivZdVYa4ouFxGqDLRFLe542_feIDMCBqY/values/Spots!D4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.1961480877',
    //         multiplier: 10,
    //     },
    // },
    // {
    //     name: 'Standard Ticket',
    //     nameFR: 'Billet régulier',
    //     description:
    //         'Join us on Saturday, February 3rd at the Coda Gala at Prima Luna Reception Hall to celebrate World Cancer Day. Enjoy a 5-course meal where all proceeds go to the Quebec Cancer Foundation. <b>Main course selection will be made by email.</b> Together, we will Shine a Light on Cancer 🌟🎗️',
    //     descriptionFR:
    //         "Rejoignez-nous samedi le 3 février pour le Gala Coda au Hall de réception Prima Luna pour célébrer la Journée mondiale contre le cancer. Dégustez la table d'hôte en 5 services au bénéfice de la Fondation québécoise du cancer. <b>Le choix du plat principal se fera par courriel.</b> Ensemble, illuminons la lutte contre le cancer 🌟🎗️",
    //     price: 150,
    //     noTag: true,
    //     folder: '2024-world-cancer-day',
    //     thumbnail: 'post.jpg',
    //     images: [
    //         ['details.png', '', '#000000'],
    //         ['post.jpg', '', '#000000'],
    //     ],
    //     imagesFR: [
    //         ['details-fr.png', '', '#000000'],
    //         ['post.jpg', '', '#000000'],
    //     ],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1pH6F4upd3FivZdVYa4ouFxGqDLRFLe542_feIDMCBqY/values/Spots!D4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.1961480877',
    //     },
    // },
    // {
    //     name: 'Early Bird Ticket',
    //     nameFR: 'Billet lève-tôt',
    //     description:
    //         '[LIMITED SPOTS] <br/>Join us on Saturday, February 3rd at the Coda Gala at Prima Luna Reception Hall to celebrate World Cancer Day. Enjoy a 5-course meal where all proceeds go to the Quebec Cancer Foundation. <b>Main course selection will be made by email.</b> Together, we will Shine a Light on Cancer 🌟🎗️',
    //     descriptionFR:
    //         "[QUANTITÉE LIMITÉE] <br/>Rejoignez-nous samedi le 3 février pour le Gala Coda au Hall de réception Prima Luna pour célébrer la Journée mondiale contre le cancer. Dégustez la table d'hôte en 5 services au bénéfice de la Fondation québécoise du cancer. <b>Le choix du plat principal se fera par courriel.</b> Ensemble, illuminons la lutte contre le cancer 🌟🎗️",
    //     price: 135,
    //     noTag: true,
    //     folder: '2024-world-cancer-day',
    //     thumbnail: 'early-bird.jpg',
    //     thumbnailFR: 'early-bird-fr.jpg',
    //     images: [
    //         ['details.png', '', '#000000'],
    //         ['early-bird.jpg', '', '#000000'],
    //     ],
    //     imagesFR: [
    //         ['details-fr.png', '', '#000000'],
    //         ['early-bird-fr.jpg', '', '#000000'],
    //     ],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1pH6F4upd3FivZdVYa4ouFxGqDLRFLe542_feIDMCBqY/values/Spots!B4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.1606317243',
    //     },
    // },
    // {
    //     name: 'Student Ticket',
    //     nameFR: 'Billet étudiant',
    //     description:
    //         '[PROOF REQUIRED] <br/>Join us on Saturday, February 3rd at the Coda Gala at Prima Luna Reception Hall to celebrate World Cancer Day. Enjoy a 5-course meal where all proceeds go to the Quebec Cancer Foundation. <b>Main course selection will be made by email.</b> Together, we will Shine a Light on Cancer 🌟🎗️',
    //     descriptionFR:
    //         "[PREUVE REQUISE] <br/>Rejoignez-nous samedi le 3 février pour le Gala Coda au Hall de réception Prima Luna pour célébrer la Journée mondiale contre le cancer. Dégustez la table d'hôte en 5 services au bénéfice de la Fondation québécoise du cancer. <b>Le choix du plat principal se fera par courriel.</b> Ensemble, illuminons la lutte contre le cancer 🌟🎗️",
    //     price: 100,
    //     noTag: true,
    //     folder: '2024-world-cancer-day',
    //     thumbnail: 'student.jpg',
    //     thumbnailFR: 'student-fr.jpg',
    //     images: [
    //         ['details.png', '', '#000000'],
    //         ['student.jpg', '', '#000000'],
    //     ],
    //     imagesFR: [
    //         ['details-fr.png', '', '#000000'],
    //         ['student-fr.jpg', '', '#000000'],
    //     ],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1pH6F4upd3FivZdVYa4ouFxGqDLRFLe542_feIDMCBqY/values/Spots!E4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.144152158',
    //     },
    // },
    // {
    //     name: 'Early Bird Student Ticket',
    //     nameFR: 'Billet étudiant lève-tôt',
    //     description:
    //         '[LIMITED SPOTS, PROOF REQUIRED] <br/>Join us on Saturday, February 3rd at the Coda Gala at Prima Luna Reception Hall to celebrate World Cancer Day. Enjoy a 5-course meal where all proceeds go to the Quebec Cancer Foundation. <b>Main course selection will be made by email.</b> Together, we will Shine a Light on Cancer 🌟🎗️',
    //     descriptionFR:
    //         "[QUANTITÉE LIMITÉE, PREUVE REQUISE] <br/>Rejoignez-nous samedi le 3 février pour le Gala Coda au Hall de réception Prima Luna pour célébrer la Journée mondiale contre le cancer. Dégustez la table d'hôte en 5 services au bénéfice de la Fondation québécoise du cancer. <b>Le choix du plat principal se fera par courriel.</b> Ensemble, illuminons la lutte contre le cancer 🌟🎗️",
    //     price: 85,
    //     noTag: true,
    //     folder: '2024-world-cancer-day',
    //     thumbnail: 'student-early.jpg',
    //     thumbnailFR: 'student-early-fr.jpg',
    //     images: [
    //         ['details.png', '', '#000000'],
    //         ['student-early.jpg', '', '#000000'],
    //     ],
    //     imagesFR: [
    //         ['details-fr.png', '', '#000000'],
    //         ['student-early-fr.jpg', '', '#000000'],
    //     ],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1pH6F4upd3FivZdVYa4ouFxGqDLRFLe542_feIDMCBqY/values/Spots!C4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.1876385579',
    //     },
    // },
    {
        name: 'Teddy Bear Clinic Fundraiser',
        nameFR: 'Clinique des doux oursons',
        description:
            "In preparation for our Teddy Bear Clinic event in collaboration with the McGill University Health Centre (MUHC), we are looking for supporters who would like to donate $10 to gift a stuffed animal to one of the 180 hospitalized children at the Montreal Children's Hospital. You will have the opportunity to name the plushie and bring it to life! (Note: you will not actually receive the plushie(s), we will distribute them during the event). ",
        descriptionFR:
            "Pour notre événement de la Clinique des doux oursons en collaboration avec le Centre universitaire de santé McGill (CUSM), nous vous encourageons à faire un don de 10$ pour offrir un animal en peluche à l'un des 180 enfants hospitalisés à l'Hôpital de Montréal pour enfants. Vous aurez l'option de donner vie à la peluche en la nommant! (Veuillez noter que vous ne recevrez pas la peluche, nous les distribuerons aux enfants lors de l'événement). ",
        price: 10,
        folder: '2023-teddy-bear-clinic',
        thumbnail: 'bundle.jpg',
        images: [['bundle.jpg'], ['frog.jpg'], ['sheep.jpg'], ['monkey.jpg'], ['dog.jpg'], ['rainbow-teddy.jpg']],
        shippingBase: 0,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    // {
    //     name: 'Snuggle Squad Bundle',
    //     description:
    //         "In preparation for our Teddy Bear Clinic event in collaboration with the McGill University Health Centre (MUHC), we are looking for supporters who would like to donate $25 to gift three stuffed animals to hospitalized children at the Montreal Children's Hospital. You will have the opportunity to name the plushies and bring them to life! (note: you will not actually receive the plushies, we will distribute them during the event). ",
    //     price: 25,
    //     folder: '2023-teddy-bear-clinic',
    //     thumbnail: 'bundle.jpg',
    //     images: [['bundle.jpg'], ['frog.jpg'], ['sheep.jpg'], ['monkey.jpg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Rainbow Teddy',
    //     description:
    //         "In preparation for our Teddy Bear Clinic event in collaboration with the McGill University Health Centre (MUHC), we are looking for supporters who would like to donate $10 to gift a stuffed animal to one of the 180 hospitalized children at the Montreal Children's Hospital. You will have the opportunity to name the plushie and bring it to life! (note: you will not actually receive the plushie(s), we will distribute them during the event). ",
    //     price: 10,
    //     folder: '2023-teddy-bear-clinic',
    //     thumbnail: 'rainbow-teddy.jpg',
    //     images: [['rainbow-teddy.jpg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 180,
    //     },
    // },
    // {
    //     name: 'Frog Plushie',
    //     description:
    //         "In preparation for our Teddy Bear Clinic event in collaboration with the McGill University Health Centre (MUHC), we are looking for supporters who would like to donate $10 to gift a stuffed animal to one of the 180 hospitalized children at the Montreal Children's Hospital. You will have the opportunity to name the plushie and bring it to life! (note: you will not actually receive the plushie(s), we will distribute them during the event). ",
    //     price: 10,
    //     folder: '2023-teddy-bear-clinic',
    //     thumbnail: 'frog.jpg',
    //     images: [['frog.jpg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 180,
    //     },
    // },
    // {
    //     name: 'Monkey Plushie',
    //     description:
    //         "In preparation for our Teddy Bear Clinic event in collaboration with the McGill University Health Centre (MUHC), we are looking for supporters who would like to donate $10 to gift a stuffed animal to one of the 180 hospitalized children at the Montreal Children's Hospital. You will have the opportunity to name the plushie and bring it to life! (note: you will not actually receive the plushie(s), we will distribute them during the event). ",
    //     price: 10,
    //     folder: '2023-teddy-bear-clinic',
    //     thumbnail: 'monkey.jpg',
    //     images: [['monkey.jpg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 180,
    //     },
    // },
    // {
    //     name: 'Sheep Plushie',
    //     description:
    //         "In preparation for our Teddy Bear Clinic event in collaboration with the McGill University Health Centre (MUHC), we are looking for supporters who would like to donate $10 to gift a stuffed animal to one of the 180 hospitalized children at the Montreal Children's Hospital. You will have the opportunity to name the plushie and bring it to life! (note: you will not actually receive the plushie(s), we will distribute them during the event). ",
    //     price: 10,
    //     folder: '2023-teddy-bear-clinic',
    //     thumbnail: 'sheep.jpg',
    //     images: [['sheep.jpg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 180,
    //     },
    // },
    // {
    //     name: 'Dog Plushie',
    //     description:
    //         "In preparation for our Teddy Bear Clinic event in collaboration with the McGill University Health Centre (MUHC), we are looking for supporters who would like to donate $10 to gift a stuffed animal to one of the 180 hospitalized children at the Montreal Children's Hospital. You will have the opportunity to name the plushie and bring it to life! (note: you will not actually receive the plushie(s), we will distribute them during the event). ",
    //     price: 10,
    //     folder: '2023-teddy-bear-clinic',
    //     thumbnail: 'dog.jpg',
    //     images: [['dog.jpg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 180,
    //     },
    // },
    {
        name: '2023 Ribbon Campaign Sweatshirt',
        nameFR: 'Sweat-shirt de la Campagne du ruban 2023',
        description:
            'This year, we brought a brand new design for our Ribbon Campaign sweaters. Each color symbolizes an underrepresented type of cancer (peach for uterine cancer, blue for colon cancer, gray for brain cancer, periwinkle for esophageal cancer and green for liver cancer) and the icons on the sleeves embody our collaboration with the Canadian Cancer Society. <br/><br/>100% of the proceeds were donated to the Canadian Cancer Society! <br/><br/>These sweatshirts were only sold for a limited time as part of our 2023 Ribbon Campaign. Follow us on Instagram (<a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">@coda.ccs</a>) to get notified when we release new merch!',
        descriptionFR:
            "Cette année, nous avons imaginé un tout nouveau design pour nos sweat-shirts de la Campagne du ruban. Chaque couleur symbolise un type de cancer sous-représenté (pêche pour le cancer de l'utérus, bleu pour le cancer du côlon, gris pour le cancer du cerveau, bleu pervenche pour le cancer de l'œsophage et vert pour le cancer du foie), et les icônes sur les manches incarnent notre collaboration avec la Société canadienne du cancer. <br/><br/>100% des profits ont été versés à la Société canadienne du cancer! <br/><br/>Ces sweat-shirts n'ont été vendus que lors de notre Campagne du ruban 2023. Suivez-nous sur Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) pour être informé lorsque nous sortirons de nouveaux articles!",
        price: 30,
        sizes: ['s', 'm', 'l', 'xl', '2xl'],
        sizingGuide: 'sweater-sizing-guide.jpg',
        folder: '2023-ribbon-campaign',
        thumbnail: 'sweater-tan.jpg',
        images: [
            ['sweater-tan.jpg', '', '#E2DACF'],
            ['sweater-indigo-blue.jpg', '', '#788DA1'],
            ['sweater-charcoal.jpg', '', '#717275'],
            ['sweater-carolina-blue.jpg', '', '#B3CBEC'],
            ['sweater-forest-green.jpg', '', '#596660'],
        ],
        shippingBase: 3,
        shippingPerItem: 6,
        stock: {
            quantity: 0,
        },
    },
    // {
    //     name: 'Esophageal Cancer Sweatshirt',
    //     description:
    //         'This year, we bring a brand new design for our Ribbon Campaign sweaters. The periwinkle color represents esophageal cancer and the icons on the sleeves symbolize our collaboration with the Canadian Cancer Society. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! Sale ends April 16th, get yours now! ',
    //     price: 30,
    //     sizes: ['s', 'm', 'l', 'xl', '2xl'],
    //     sizingGuide: 'sweater-sizing-guide.jpg',
    //     folder: '2023-ribbon-campaign',
    //     thumbnail: 'sweater-carolina-blue.jpg',
    //     images: [['sweater-carolina-blue.jpg', '', '#B3CBEC']],
    //     shippingBase: 3,
    //     shippingPerItem: 6,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Brain Cancer Sweatshirt',
    //     description:
    //         'This year, we bring a brand new design for our Ribbon Campaign sweaters. The gray color represents brain cancer and the icons on the sleeves symbolize our collaboration with the Canadian Cancer Society. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! Sale ends April 16th, get yours now! ',
    //     price: 30,
    //     sizes: ['s', 'm', 'l', 'xl', '2xl'],
    //     sizingGuide: 'sweater-sizing-guide.jpg',
    //     folder: '2023-ribbon-campaign',
    //     thumbnail: 'sweater-charcoal.jpg',
    //     images: [['sweater-charcoal.jpg', '', '#717275']],
    //     shippingBase: 3,
    //     shippingPerItem: 6,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Uterine Cancer Sweatshirt',
    //     description:
    //         'This year, we bring a brand new design for our Ribbon Campaign sweaters. The peach color represents uterine cancer and the icons on the sleeves symbolize our collaboration with the Canadian Cancer Society. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! Sale ends April 16th, get yours now! ',
    //     price: 30,
    //     sizes: ['s', 'm', 'l', 'xl', '2xl'],
    //     sizingGuide: 'sweater-sizing-guide.jpg',
    //     folder: '2023-ribbon-campaign',
    //     thumbnail: 'sweater-tan.jpg',
    //     images: [['sweater-tan.jpg', '', '#E2DACF']],
    //     shippingBase: 3,
    //     shippingPerItem: 6,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Liver Cancer Sweatshirt',
    //     description:
    //         'This year, we bring a brand new design for our Ribbon Campaign sweaters. The green color represents liver cancer and the icons on the sleeves symbolize our collaboration with the Canadian Cancer Society. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! Sale ends April 16th, get yours now! ',
    //     price: 30,
    //     sizes: ['s', 'm', 'l', 'xl', '2xl'],
    //     sizingGuide: 'sweater-sizing-guide.jpg',
    //     folder: '2023-ribbon-campaign',
    //     thumbnail: 'sweater-forest-green.jpg',
    //     images: [['sweater-forest-green.jpg', '', '#596660']],
    //     shippingBase: 3,
    //     shippingPerItem: 6,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Colon Cancer Sweatshirt',
    //     description:
    //         'This year, we bring a brand new design for our Ribbon Campaign sweaters. The blue color represents colon cancer and the icons on the sleeves symbolize our collaboration with the Canadian Cancer Society. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! Sale ends April 16th, get yours now! ',
    //     price: 30,
    //     sizes: ['s', 'm', 'l', 'xl', '2xl'],
    //     sizingGuide: 'sweater-sizing-guide.jpg',
    //     folder: '2023-ribbon-campaign',
    //     thumbnail: 'sweater-indigo-blue.jpg',
    //     images: [['sweater-indigo-blue.jpg', '', '#788DA1']],
    //     shippingBase: 3,
    //     shippingPerItem: 6,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    {
        name: '2023 World Cancer Day Pins',
        nameFR: 'Épinglettes de la Journée mondiale contre le cancer 2023',
        description:
            "These high-quality 1-inch enamel pins are a great way of showing your support for cancer patients across the country. The rubber clutch holds on tight and won't irritate your skin. <br/><br/>100% of the proceeds were donated to the Canadian Cancer Society! <br/><br/>These pins were only sold during our 2023 World Cancer Day event on February 4th. Follow us on Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) to get notified when we release new merch!",
        descriptionFR:
            "Ces épinglettes en émail de haute qualité sont un excellent moyen de montrer votre soutien aux patients atteints de cancer à travers le pays. <br/><br/>100% des profits ont été versés à la Société canadienne du cancer! <br/><br/>Ces épinglettes n'ont été vendues que lors de notre événement de la Journée mondiale contre le cancer le 4 février 2023. Suivez-nous sur Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) pour être informé lorsque nous sortirons de nouveaux articles!",
        price: 5,
        folder: '2023-world-cancer-day',
        thumbnail: 'pins.jpg',
        images: [['pins.jpg'], ['pink-pin-1.jpg'], ['pink-pin-2.jpg']],
        shippingBase: 2,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: '2023 World Cancer Day T&#8209;Shirt',
        nameFR: 'T&#8209;shirt de la Journée mondiale contre le cancer 2023',
        description:
            "Wear this T-shirt to stand in solidarity with cancer patients across the country. The lavender ribbon stands out on the charcoal gray background and shows your support for the cause. <br/><br/>100% of the proceeds were donated to the Canadian Cancer Society! <br/><br/>This t-shirt was only sold during our 2022 World Cancer Day event on February 4th. Follow us on Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) to get notified when we release new merch!",
        descriptionFR:
            "Portez ce t-shirt pour montrer votre solidarité envers les patients atteints de cancer à travers le pays. Le ruban lavande ressort sur le fond gris anthracite et affiche votre soutien à la cause. <br/><br/>100% des profits ont été versés à la Société canadienne du cancer! <br/><br/>Ces t-shirts n'ont été vendus que lors de notre événement de la Journée mondiale contre le cancer le 4 février 2023. Suivez-nous sur Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) pour être informé lorsque nous sortirons de nouveaux articles!",
        price: 20,
        folder: '2023-world-cancer-day',
        thumbnail: 't-shirt.png',
        images: [['t-shirt.png'], ['t-shirt-close-up.jpg']],
        shippingBase: 2,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
        },
    },
    {
        name: 'Breast Cancer Awareness Pin',
        nameFR: 'Épinglette de sensibilisation au cancer du sein',
        description:
            "These high-quality 1-inch enamel pins are a great way of showing your support for breast cancer patients across the country. The rubber clutch holds on tight and won't irritate your skin. <br/><br/>100% of the proceeds were donated to the Canadian Cancer Society! <br/><br/>This pin was only sold during our 2022 Breast Cancer Awareness Month. Follow us on Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) to get notified when we release new merch!",
        descriptionFR:
            "Ces épinglettes en émail de haute qualité sont un excellent moyen de montrer votre soutien aux patientes atteintes de cancer du sein à travers le pays. <br/><br/>100% des profits ont été versés à la Société canadienne du cancer! <br/><br/>Ces épinglettes n'ont été vendues que lors de notre Mois de sensibilisation au cancer du sein 2022. Suivez-nous sur Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) pour être informé lorsque nous sortirons de nouveaux articles!",
        price: 4,
        folder: '2022-breast-cancer-month',
        thumbnail: 'pin-1.jpg',
        images: [['pin-1.jpg'], ['pin-2.jpg'], ['pin-3.jpg'], ['pin-4.jpg'], ['pin-5.jpg']],
        shippingBase: 2,
        shippingPerItem: 0,
        stock: {
            quantity: 0,
            // readLink:
            //     'https://sheets.googleapis.com/v4/spreadsheets/1l8ztNmF0pNV8bOKkmqiBeVqnwEiKh2WJsulS9Avwqmo/values/Stock!F4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
            // writeID: 'entry.1212348438',
            // multiplier: 1,
        },
    },
    {
        name: 'Breast Cancer Awareness T&#8209;Shirt',
        nameFR: 'T&#8209;shirt de sensibilisation au cancer du sein',
        description:
            "Wear this T-shirt to stand in solidarity with breast cancer patients across the country. The bright pink ribbon stands out on the charcoal gray background and shows your support for the cause. <br/><br/>100% of the proceeds were donated to the Canadian Cancer Society! <br/><br/>This t-shirt was only sold during our 2022 Breast Cancer Awareness Month. Follow us on Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) to get notified when we release new merch!",
        descriptionFR:
            "Portez ce t-shirt pour montrer votre solidarité envers les patientes atteintes de cancer du sein à travers le pays. Le ruban rose fluo ressort sur le fond gris anthracite et affiche votre soutien à la cause. <br/><br/>100% des profits ont été versés à la Société canadienne du cancer! <br/><br/>Ces t-shirts n'ont été vendus que lors de notre Mois de sensibilisation au cancer du sein 2022. Suivez-nous sur Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) pour être informé lorsque nous sortirons de nouveaux articles!",
        price: 20,
        sizes: ['s', 'm', 'l', 'xl'],
        // sizingGuide: 't-shirt.png',
        folder: '2022-breast-cancer-month',
        thumbnail: 't-shirt.png',
        images: [['t-shirt.png']],
        shippingBase: 2,
        shippingPerItem: 4,
        stock: {
            quantity: 0,
            // quantity: 999,
        },
    },
    // {
    //     name: 'T-shirt contre le cancer du sein',
    //     description:
    //         'Portez ce T-shirt pour montrer votre support pour les patientes atteintes du cancer du sein à travers le pays. <br/><br/>100% des profits seront versés à la Société canadienne du cancer! ',
    //     price: 20,
    //     sizes: ['p', 'm', 'l', 'xl'],
    //     // sizingGuide: 't-shirt.png',
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: 't-shirt-fr.png',
    //     images: [['t-shirt-fr.png']], //['more-fr.jpg', 'black-bg']],
    //     isFrench: true,
    //     shippingBase: 2,
    //     shippingPerItem: 4,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Breast Cancer Awareness Hoodie',
    //     description:
    //         'This high-quality sublimated zip-up hoodie is made from 100% dry-fit polyester with a fleece lining, making it perfect for indoor or outdoor wear. The quality of the printing process means that the hoodies will retain their vibrant colors through years of continued use. <br/><br/><b>Extremely stylish, extremely limited stock!</b> <br/><br/>See the <a href="/images/products/2022-breast-cancer-month/hoodie-sizing-guide.jpg" target="_blank" rel="noopener noreferrer">sizing guide</a> to find the perfect hoodie for you! <br/><br/>This hoodie was only sold during our 2022 Breast Cancer Awareness Month. 100% of the proceeds were donated to the Canadian Cancer Society to support breast cancer patients across the country! ',
    //     price: 60,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: 'hoodie-3d-render.jpg',
    //     images: [['hoodie-3d-render.jpg', 'black-bg'], ['hoodie-front.jpg'], ['hoodie-back.jpg'], ['hoodie-side.png', 'black-bg']],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Small Breast Cancer Awareness Hoodie',
    //     description:
    //         'This high-quality sublimated zip-up hoodie is made from 100% dry-fit polyester with a fleece lining, making it perfect for indoor or outdoor wear. The quality of the printing process means that the hoodies will retain their vibrant colors through years of continued use. <br/><br/><b>Extremely stylish, extremely limited stock!</b> <br/><br/>See the <a href="/images/products/2022-breast-cancer-month/hoodie-sizing-guide.jpg" target="_blank" rel="noopener noreferrer">sizing guide</a> to find the perfect hoodie for you! <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society to support breast cancer patients across the country!  ',
    //     price: 60,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: 'hoodie-3d-render.png',
    //     images: [
    //         ['hoodie-3d-render.png', 'black-bg'],
    //         ['hoodie-front.png', 'black-bg'],
    //         ['hoodie-back.png', 'black-bg'],
    //         ['hoodie-side.png', 'black-bg'],
    //         ['more.jpg', 'black-bg'],
    //     ],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1l8ztNmF0pNV8bOKkmqiBeVqnwEiKh2WJsulS9Avwqmo/values/Stock!B4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.1606317243',
    //     },
    // },
    // {
    //     name: 'Medium Breast Cancer Awareness Hoodie',
    //     description:
    //         'This high-quality sublimated zip-up hoodie is made from 100% dry-fit polyester with a fleece lining, making it perfect for indoor or outdoor wear. The quality of the printing process means that the hoodies will retain their vibrant colors through years of continued use. <br/><br/><b>Extremely stylish, extremely limited stock!</b> <br/><br/>See the <a href="/images/products/2022-breast-cancer-month/hoodie-sizing-guide.jpg" target="_blank" rel="noopener noreferrer">sizing guide</a> to find the perfect hoodie for you! <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society to support breast cancer patients across the country!  ',
    //     price: 60,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: 'hoodie-3d-render.png',
    //     images: [
    //         ['hoodie-3d-render.png', 'black-bg'],
    //         ['hoodie-front.png', 'black-bg'],
    //         ['hoodie-back.png', 'black-bg'],
    //         ['hoodie-side.png', 'black-bg'],
    //         ['more.jpg', 'black-bg'],
    //     ],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1l8ztNmF0pNV8bOKkmqiBeVqnwEiKh2WJsulS9Avwqmo/values/Stock!C4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.1876385579',
    //     },
    // },
    // {
    //     name: 'Large Breast Cancer Awareness Hoodie',
    //     description:
    //         'This high-quality sublimated zip-up hoodie is made from 100% dry-fit polyester with a fleece lining, making it perfect for indoor or outdoor wear. The quality of the printing process means that the hoodies will retain their vibrant colors through years of continued use. <br/><br/><b>Extremely stylish, extremely limited stock!</b> <br/><br/>See the <a href="/images/products/2022-breast-cancer-month/hoodie-sizing-guide.jpg" target="_blank" rel="noopener noreferrer">sizing guide</a> to find the perfect hoodie for you! <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society to support breast cancer patients across the country!  ',
    //     price: 60,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: 'hoodie-3d-render.png',
    //     images: [
    //         ['hoodie-3d-render.png', 'black-bg'],
    //         ['hoodie-front.png', 'black-bg'],
    //         ['hoodie-back.png', 'black-bg'],
    //         ['hoodie-side.png', 'black-bg'],
    //         ['more.jpg', 'black-bg'],
    //     ],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1l8ztNmF0pNV8bOKkmqiBeVqnwEiKh2WJsulS9Avwqmo/values/Stock!D4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.1961480877',
    //     },
    // },
    // {
    //     name: 'Extra-Large Breast Cancer Awareness Hoodie',
    //     description:
    //         'This high-quality sublimated zip-up hoodie is made from 100% dry-fit polyester with a fleece lining, making it perfect for indoor or outdoor wear. The quality of the printing process means that the hoodies will retain their vibrant colors through years of continued use. <br/><br/><b>Extremely stylish, extremely limited stock!</b> <br/><br/>See the <a href="/images/products/2022-breast-cancer-month/hoodie-sizing-guide.jpg" target="_blank" rel="noopener noreferrer">sizing guide</a> to find the perfect hoodie for you! <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society to support breast cancer patients across the country!  ',
    //     price: 60,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: 'hoodie-3d-render.png',
    //     images: [
    //         ['hoodie-3d-render.png', 'black-bg'],
    //         ['hoodie-front.png', 'black-bg'],
    //         ['hoodie-back.png', 'black-bg'],
    //         ['hoodie-side.png', 'black-bg'],
    //         ['more.jpg', 'black-bg'],
    //     ],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         readLink:
    //             'https://sheets.googleapis.com/v4/spreadsheets/1l8ztNmF0pNV8bOKkmqiBeVqnwEiKh2WJsulS9Avwqmo/values/Stock!E4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE',
    //         writeID: 'entry.144152158',
    //     },
    // },
    // {
    //     name: 'Twenty Raffle Tickets',
    //     description:
    //         '<b>Spooky Halloween Deal! </b><br/>Get 20 tickets for only $20! <br/><br/>Each raffle ticket grants you one entry to our raffle on the 1st of November. The more tickets you get, the higher your chances of winning! Proceeds will help Coda conduct future events and projects. <br/><br/>The prizes include a brand new pair of <a href="https://www.apple.com/ca/airpods-pro/" target="_blank" rel="noopener noreferrer">Apple AirPods Pro (2nd generation)</a> (the latest and greatest!), a limited edition Coda breast cancer hoodie, two Coda breast cancer T-shirts, and tens of gift cards, for a total value of <b>over $700!</b> <br/><br/><b>The raffle is scheduled as follows: </b><br/>Tuesday, November 1: Gift cards <br/>Wednesday, November 2: Coda merch <br/>Thursday, November 3: Apple AirPods Pro',
    //     price: 20,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: 'raffle.jpg',
    //     images: [['raffle.jpg'], ['raffle-deal-post.jpg', 'black-bg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 0,
    //         multiplier: 20,
    //     },
    // },
    // {
    //     name: 'Three Raffle Tickets',
    //     description:
    //         'Each raffle ticket grants you one entry to our raffle on the 1st of November. The more tickets you get, the higher your chances of winning! Proceeds will help Coda conduct future events and projects. <br/><br/>The prizes include a brand new pair of <a href="https://www.apple.com/ca/airpods-pro/" target="_blank" rel="noopener noreferrer">Apple AirPods Pro (2nd generation)</a> (the latest and greatest!), a limited edition Coda breast cancer hoodie, two Coda breast cancer T-shirts, and tens of gift cards, for a total value of <b>over $700!</b> <br/><br/><b>The raffle is scheduled as follows: </b><br/>Tuesday, November 1: Gift cards <br/>Wednesday, November 2: Coda merch <br/>Thursday, November 3: Apple AirPods Pro',
    //     price: 5,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: '3-tickets.jpg',
    //     images: [['3-tickets.jpg'], ['raffle.jpg'], ['raffle-post.jpg', 'black-bg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 0,
    //         multiplier: 3,
    //     },
    // },
    // {
    //     name: 'One Raffle Ticket',
    //     description:
    //         'Each raffle ticket grants you one entry to our raffle on the 1st of November. The more tickets you get, the higher your chances of winning! Proceeds will help Coda conduct future events and projects. <br/><br/>The prizes include a brand new pair of <a href="https://www.apple.com/ca/airpods-pro/" target="_blank" rel="noopener noreferrer">Apple AirPods Pro (2nd generation)</a> (the latest and greatest!), a limited edition Coda breast cancer hoodie, two Coda breast cancer T-shirts, and tens of gift cards, for a total value of <b>over $700!</b> <br/><br/><b>The raffle is scheduled as follows: </b><br/>Tuesday, November 1: Gift cards <br/>Wednesday, November 2: Coda merch <br/>Thursday, November 3: Apple AirPods Pro',
    //     price: 2,
    //     folder: '2022-breast-cancer-month',
    //     thumbnail: '1-ticket.jpg',
    //     images: [['1-ticket.jpg'], ['raffle.jpg'], ['raffle-post.jpg', 'black-bg']],
    //     shippingBase: 0,
    //     shippingPerItem: 0,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    {
        name: '2022 Ribbon Campaign Hoodies',
        nameFR: 'Hoodie de la Campagne du ruban 2022',
        description:
            'Awesome minimalistic Coda-branded hoodies. The embroidered ribbon represents different types of cancers: gold for childhood cancer, pink for breast cancer, light blue for prostate cancer and lavender for all cancers. <br/><br/>100% of the proceeds were donated to the Canadian Cancer Society! <br/><br/>These hoodies were only sold for a limited time as part of our 2022 Ribbon Campaign. Follow us on Instagram (<a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">@coda.ccs</a>) to get notified when we release new merch!',
        descriptionFR:
            "Découvrez nos superbes hoodies minimalistes. Le ruban brodé représente différents types de cancers : doré pour le cancer de l'enfance, rose pour le cancer du sein, bleu clair pour le cancer de la prostate et lavande pour tous les cancers. <br/><br/>100% des profits ont été versés à la Société canadienne du cancer! <br/><br/>Ces hoodies n'ont été vendus que lors de notre Campagne du ruban 2022. Suivez-nous sur Instagram (<a href='https://instagram.com/coda.ccs' target='_blank' rel='noopener noreferrer'>@coda.ccs</a>) pour être informé lorsque nous sortirons de nouveaux articles!",
        price: 39,
        sizes: ['s', 'm', 'l', 'xl'],
        sizingGuide: 'hoodie-sizing-guide.jpg',
        folder: '2022-ribbon-campaign-hoodie',
        thumbnail: 'lavender-hoodie-front.png',
        images: [
            ['1.jpg'],
            ['2.jpg'],
            ['3.jpg'],
            ['4.jpg'],
            ['lavender-hoodie-front.png'],
            ['gold-hoodie-front.png'],
            ['pink-hoodie-front.png'],
            ['blue-hoodie-front.png'],
            ['hoodie-back.png'],
        ],
        shippingBase: 4,
        shippingPerItem: 5,
        stock: {
            quantity: 0,
        },
    },
    // {
    //     name: 'All Cancers Hoodie',
    //     description:
    //         'Awesome minimalistic Coda-branded hoodie. The embroidered lavender ribbon represents all cancers. As such, proceeds from this hoodie will benefit all cancers. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! <br/><br/>This hoodie was only sold for a limited time as part of The Ribbon Campaign. Follow us on Instagram (<a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">@coda.ccs</a>) to get notified when we release new merch!',
    //     price: 39,
    //     sizes: ['s', 'm', 'l', 'xl'],
    //     sizingGuide: 'hoodie-sizing-guide.jpg',
    //     folder: '2022-ribbon-campaign-hoodie',
    //     thumbnail: 'lavender-hoodie-front.png',
    //     images: [['lavender-hoodie-front.png'], ['hoodie-back.png'], ['1.jpg'], ['2.jpg'], ['3.jpg'], ['4.jpg']],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Childhood Cancer Hoodie',
    //     description:
    //         'Awesome minimalistic Coda-branded hoodie. The embroidered gold-colored ribbon represents childhood cancer. As such, proceeds from this hoodie will benefit childhood cancer. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! <br/><br/>This hoodie was only sold for a limited time as part of The Ribbon Campaign. Follow us on Instagram (<a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">@coda.ccs</a>) to get notified when we release new merch!',
    //     price: 39,
    //     sizes: ['s', 'm', 'l', 'xl'],
    //     sizingGuide: 'hoodie-sizing-guide.jpg',
    //     folder: '2022-ribbon-campaign-hoodie',
    //     thumbnail: 'gold-hoodie-front.png',
    //     images: [['gold-hoodie-front.png'], ['hoodie-back.png'], ['1.jpg'], ['2.jpg'], ['3.jpg'], ['4.jpg']],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Breast Cancer Hoodie',
    //     description:
    //         'Awesome minimalistic Coda-branded hoodie. The embroidered pink ribbon represents breast cancer. As such, proceeds from this hoodie will benefit breast cancer. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! <br/><br/>This hoodie was only sold for a limited time as part of The Ribbon Campaign. Follow us on Instagram (<a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">@coda.ccs</a>) to get notified when we release new merch!',
    //     price: 39,
    //     sizes: ['s', 'm', 'l', 'xl'],
    //     sizingGuide: 'hoodie-sizing-guide.jpg',
    //     folder: '2022-ribbon-campaign-hoodie',
    //     thumbnail: 'pink-hoodie-front.png',
    //     images: [['pink-hoodie-front.png'], ['hoodie-back.png'], ['2.jpg'], ['1.jpg'], ['3.jpg'], ['4.jpg']],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    // {
    //     name: 'Prostate Cancer Hoodie',
    //     description:
    //         'Awesome minimalistic Coda-branded hoodie. The embroidered light blue ribbon represents prostate cancer. As such, proceeds from this hoodie will benefit prostate cancer. <br/><br/>100% of the proceeds will be donated to the Canadian Cancer Society! <br/><br/>This hoodie was only sold for a limited time as part of The Ribbon Campaign. Follow us on Instagram (<a href="https://instagram.com/coda.ccs" target="_blank" rel="noopener noreferrer">@coda.ccs</a>) to get notified when we release new merch!',
    //     price: 39,
    //     sizes: ['s', 'm', 'l', 'xl'],
    //     sizingGuide: 'hoodie-sizing-guide.jpg',
    //     folder: '2022-ribbon-campaign-hoodie',
    //     thumbnail: 'blue-hoodie-front.png',
    //     images: [['blue-hoodie-front.png'], ['hoodie-back.png'], ['3.jpg'], ['1.jpg'], ['2.jpg'], ['4.jpg']],
    //     shippingBase: 4,
    //     shippingPerItem: 5,
    //     stock: {
    //         quantity: 0,
    //     },
    // },
    {
        name: 'About This Shop',
        nameFR: 'À propos de la boutique',
        description:
            "Coda is very proud to present its e&#8209;commerce store! <br/><br/>We source our products from reputable manufacturers with a history of producing high quality merchandise and apparel. <br/><br/>As we don't currently hold inventory, manufaturing time and delivery can take a few weeks. <br/><br/>All proceeds go either directly to the Canadian Cancer Society (CCS), to a different charity if specified, or towards funding our future events. ",
        descriptionFR:
            'Coda est très fier de présenter sa boutique en ligne! <br/><br/>Nous obtenons nos produits auprès de fabricants réputés et qui ont une longue histoire de production de vêtements et de marchandises de haute qualité. <br/><br/>Comme nous ne détenons actuellement aucun stock, le temps de fabrication et de livraison peut prendre quelques semaines.<br/><br/>Tous les bénéfices sont soit versés directement à la Société canadienne du cancer (SCC) ou à une autre organisation caritative, ou seront utilisés pour financer nos futurs événements, le cas échéant.',
        folder: 'shop',
        thumbnail: 'shop.jpg',
        images: [['shop.jpg', 'cover']],
    },
]

const productsGrid = document.querySelector('.products-grid')
// Loop through all the products
for (let i = 0; i < PRODUCTS.length; i++) {
    let p = PRODUCTS[i]

    // Create the HTML elements from the product objects
    p.container = document.createElement('div')
    p.container.classList.add('product-container')
    p.container.title = isFR ? p.nameFR || p.name : p.name
    p.container.tabIndex = 0

    let inStock = true
    if (p.stock) {
        if (p.stock.quantity === 0) {
            inStock = false
        }
    } else {
        inStock = false
    }

    p.container.innerHTML = `
        <div class="product ${p.noTag ? 'no-tag' : ''}" data-name="${isFR ? p.nameFR || p.name : p.name}" data-price="${
        inStock ? (isFR ? p.price + '$' : '$' + p.price) : ''
    }">
            <div class="thumbnail" style="background-image: url(/images/products/${p.folder}/${isFR ? p.thumbnailFR || p.thumbnail : p.thumbnail});${
        p.containThumbnail ? 'background-size: contain;background-color: ' + p.containThumbnail : ''
    }"></div>
            <div class="data" style="display: none">
                ${getImagesHTML(p)}
                <div class="details ${inStock ? '' : 'one-column'}">
                    <div class="name">${isFR ? p.nameFR || p.name : p.name}</div>
                    <div class="description">${isFR ? p.descriptionFR || p.description : p.description}</div>
                    ${inStock ? `<div class="price"><div class="price-tag ${p.price > 999 ? 'long' : ''}">${p.price}</div></div>` : ''}
                    ${inStock ? getSizesHTML(p, i) : ''}
                    ${
                        inStock
                            ? `<div class="button-container">
                                <input class="quantity" type="text" value="1" maxlength="2" />
                                <input class="button" type="button" id="${p.folder}-${i}-button" value="${isFR ? 'Ajouter' : 'Add to cart'}" />
                                <label class="cart-icon" for="${p.folder}-${i}-button"></label>
                                </div>`
                            : ''
                    }
                </div>
            </div>
        </div>`
    // Insert the products in the grid
    productsGrid.appendChild(p.container)

    getStock(p)
}

// Send GET request
function fetchStock(product, callback) {
    var xmlHttp = new XMLHttpRequest()
    xmlHttp.onreadystatechange = function () {
        // Check if request is done
        if (xmlHttp.readyState == 4) {
            // Check if request is successful
            if (xmlHttp.status == 200) {
                return callback(product, JSON.parse(xmlHttp.response))
            }
            // Wait until the request is done before checking for error
            else {
                showBanner("We couldn't fetch the data :(", 'Une erreur est survenue :(', 0)
            }
        }
    }
    xmlHttp.open('GET', product.stock.readLink, true)
    xmlHttp.send(null)
}
function updateStock(product, response) {
    if (response.values) {
        product.stock.quantity = parseInt(response.values[0][0])
    } else {
        product.stock.quantity = 0
    }
    // Update the out-of-stock status after getting the results back
    setOutOfStock(product)

    return product.stock.quantity
}
function getStock(product) {
    // If stock is not specified, do not mark as out-of-stock
    if (!product.stock) {
        product.stock = { quantity: 1 }
        return product.stock.quantity
    }
    // Send GET request to Google Sheets API
    if (product.stock.readLink) {
        return fetchStock(product, updateStock)
    }
    // If stock is not hard-coded (example 0 for out of stock status)
    if (typeof product.stock.quantity == 'number') {
        setOutOfStock(product)
        return product.stock.quantity
    }
}
function setOutOfStock(product) {
    let productElement = product.container.querySelector('.product')

    if (product.stock.quantity > 0) {
        if (productElement) productElement.classList.add('in-stock')
        return
    }

    // Add out-of-stock class
    if (productElement) {
        productElement.classList.add('out-of-stock')
    }
    let detailsElement = product.container.querySelector('.details')
    if (detailsElement) {
        detailsElement.classList.add('one-column')
    }
    // Hide elements if sold out
    hide(product.container.querySelector('.price'))
    hide(product.container.querySelector('.sizes'))
    hide(product.container.querySelector('.button-container'))
}
function hide(element) {
    if (element) {
        element.style.display = 'none'
        element.style.visibility = 'hidden'
    }
}

// For each image, set the correct path and add classes if needed
function getImagesHTML(productObject) {
    let imagesHTML = ''
    let imagesArray = isFR ? productObject.imagesFR || productObject.images : productObject.images
    for (let image of imagesArray) {
        imagesHTML += `<img src="data:," data-src="/images/products/${productObject.folder}/${image[0]}" class="${
            image[1] ? image[1] : ''
        }" style="background-color: ${image[2] ? image[2] : ''};" />`
    }
    return imagesHTML
}
// For each size, create an input element with a unique ID
function getSizesHTML(productObject, index) {
    if (!productObject.sizes) return ''

    let sizesHTML = '<div class="sizes">'
    for (let j = 0; j < productObject.sizes.length; j++) {
        let size = productObject.sizes[j]
        let sizePrefix = `${productObject.folder}-${index}`
        sizesHTML += `<input type="radio" name="${sizePrefix}-radio" id="${sizePrefix}-${size}" ${j === 1 ? 'checked' : ''} />
                      <label class="size" for="${sizePrefix}-${size}">${size}</label>`
    }
    // Add the link for the sizing guide if needed
    if (productObject.sizingGuide) {
        sizesHTML += `<a class="sizing-guide" href="/images/products/${productObject.folder}/${
            productObject.sizingGuide
        }" target="_blank" rel="noopener noreferrer">${isFR ? 'Grandeurs' : 'Sizing guide'}</a>`
    }
    return sizesHTML + '</div>'
}

// Get all the products in the grid
const products = document.querySelectorAll('.product-container')
// Elements for the product card
const productView = document.querySelector('.product-view')
const productViewCard = document.querySelector('.product-view .card')
const gallery = document.querySelector('.product-view .gallery')
const leftGalleryArrow = document.querySelector('.gallery .arrow.left')
const rightGalleryArrow = document.querySelector('.gallery .arrow.right')
const detailsPanel = document.querySelector('.product-view .details-panel')
// Elements for the cart
const confirmItContent = document.querySelector('.confirm-it .content')
const cartItemTemplate = document.querySelector('template#cart-item')
const cartContainer = document.querySelector('.confirm-it .cart-container')
const cartTotal = document.querySelector('#cart-total')
// Elements for client info
const sendItContent = document.querySelector('.send-it .content')
const form = document.querySelector('#order-form')
const fieldset = document.querySelector('#order-form fieldset')
const clientName = document.querySelector('#client-name')
const clientEmail = document.querySelector('#client-email')
const sendReminders = document.querySelector('#send-reminders')
const pickUp = document.querySelector('#pickup-at-coda')
const shipIt = document.querySelector('#ship-it')
const shippingFee = document.querySelector('#shipping-fee')
const pickupLocation = document.querySelector('#pickup-location-1')
const shippingAddress = form.querySelector('.shipping-address')
const clientAddress = form.querySelector('#client-address')
const clientCity = form.querySelector('#client-city')
const clientProvince = form.querySelector('#client-province')
const clientPostalCode = form.querySelector('#client-postal-code')
const submitButton = form.querySelector('input[type="submit"]')
// Elements for payment section
const payItCircle = document.querySelector('#pay-it')
const paypalFeeElement = document.querySelector('#paypal-fee')
const payItContent = document.querySelector('.pay-it .content')
const orderAmount = document.querySelector('#order-amount')
const orderID = document.querySelector('#order-id')

const cart = []
// Used to generate order ID
const startTime = Date.now()

let productOpen = false
let currentThumbnail = null
let currentData = null
let galleryIndex = 0
let galleryImages = []
let productDetails = null
let quantityInput = null
let cartButton = null

// Product card starts transparent, centered and translated down a bit (for future animation)
gsap.set(productView, {
    opacity: 0,
})
gsap.set(productViewCard, {
    xPercent: -50,
    yPercent: 20,
})

// Open product view when user clicks on product
products.forEach((product) => {
    // When user presses enter when focused on the product
    product.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
            product.click()
        }
    })
    product.addEventListener('click', openProductView)
})

function openProductView() {
    if (productOpen) return
    productOpen = true

    // Get the product data and insert it in the card
    resetProductCard(this)
    // Prevent scrolling
    document.body.style.overflowY = 'hidden'
    // Show the card
    gsap.to(productView, {
        opacity: 1,
        duration: 0.5,
        onComplete: () => {
            productView.style.pointerEvents = 'all'
        },
    })
    // Translate the card up
    gsap.to(productViewCard, {
        yPercent: 0,
        duration: 0.5,
        ease: 'power4.out',
    })
}

// Populate the product card with the appropriate data
function resetProductCard(product) {
    // Save the element containing the data
    currentData = product.querySelector('.data')
    // Save the current thumbnail
    currentThumbnail = product.querySelector('.thumbnail')

    // Save the current quantity and cart button elements
    quantityInput = currentData.querySelector('.quantity')
    cartButton = currentData.querySelector('.button')
    if (quantityInput) {
        // Validate initial quantity
        let eObject = { target: quantityInput }
        validateQuantity(eObject)
        // Validate value on user input
        quantityInput.addEventListener('input', validateQuantity)
    }
    if (cartButton) {
        cartButton.addEventListener('click', addToCart, { once: true })
    }

    // Reset gallery index and get the product images
    galleryIndex = 0
    galleryImages = currentData.querySelectorAll('img')
    // Load the images by setting the src and add them to the gallery
    gsap.set(galleryImages, {
        xPercent: (index, image) => {
            // Only change the src if it's not already the correct one
            if (!image.src.includes(image.dataset.src)) {
                image.src = image.dataset.src
            }
            gallery.appendChild(image)
            return index === 0 ? -50 : 50
        },
        yPercent: -50,
    })

    // Get the product details and add to the card
    productDetails = currentData.querySelector('.details')
    detailsPanel.appendChild(productDetails)
}

// Previous image
leftGalleryArrow.addEventListener('click', () => {
    // If the index is invalid
    if (!galleryImages[galleryIndex]) return
    // If it's the first image
    if (galleryIndex === 0) return

    // Move current image to the right
    gsap.to(galleryImages[galleryIndex], {
        xPercent: 150,
        duration: 0.5,
        ease: 'expo.inOut',
    })
    // Move previous image into view
    galleryIndex -= 1
    gsap.to(galleryImages[galleryIndex], {
        xPercent: -50,
        duration: 0.5,
        ease: 'expo.inOut',
    })
})
// Next image
rightGalleryArrow.addEventListener('click', () => {
    // If the index is invalid
    if (!galleryImages[galleryIndex]) return
    // If it's the last image
    if (galleryIndex === galleryImages.length - 1) return

    // Move current image to the left
    gsap.to(galleryImages[galleryIndex], {
        xPercent: -250,
        duration: 0.5,
        ease: 'expo.inOut',
    })
    // Move next image into view
    galleryIndex += 1
    gsap.to(galleryImages[galleryIndex], {
        xPercent: -50,
        duration: 0.5,
        ease: 'expo.inOut',
    })
})

// Close product view when user clicks outside of card or on close button
document.addEventListener('click', (e) => {
    if (e.target.matches('.product-view .background') || e.target.matches('.product-view .close-button')) {
        closeProductCard()
    }
})

function closeProductCard() {
    document.body.style.overflowY = 'auto'
    productView.style.pointerEvents = 'none'
    // Remove input validator
    if (quantityInput) {
        quantityInput.removeEventListener('input', validateQuantity)
        quantityInput = null
    }
    // Remove button click event
    if (cartButton) {
        cartButton.removeEventListener('click', addToCart)
        cartButton = null
    }
    // Fade out and translate down the product card
    gsap.to(productView, {
        opacity: 0,
        duration: 0.4,
    })
    gsap.to(productViewCard, {
        yPercent: 20,
        duration: 0.4,
        ease: 'power1.in',
        onComplete: () => {
            // Move the product images and details back to their original product element
            galleryImages.forEach((image) => {
                currentData.appendChild(image)
            })
            currentData.appendChild(productDetails)
            productOpen = false
        },
    })
}

function validateQuantity(e) {
    let element = e.target
    // Get input value
    let inputValue = element.value
    if (!element.previousQuantity) {
        element.previousQuantity = 1
    }
    // If no value, disable button, but do not change value automatically
    if (inputValue === '') {
        if (cartButton) {
            cartButton.disabled = true
        }
        element.previousQuantity = element.value
        return
    }

    // Get the last digit of the input
    let inputDigit = parseInt(inputValue.charAt(inputValue.length - 1))
    // If it's not a number or 0, revert back to previous value
    if (isNaN(inputDigit) || inputDigit === 0) {
        element.value = element.previousQuantity
        return
    }

    // Re-enable cart button, replace the quantity with the current value and save as the previous quantity
    if (cartButton) {
        cartButton.disabled = false
    }
    element.value = inputDigit
    element.previousQuantity = inputDigit

    // Check if there is a corresponding item object in the cart array
    if (element.parentElement.cartItem) {
        // Update the quantity in the cart array
        element.parentElement.cartItem.quantity = inputDigit
        // Update cart total and update shipping fee
        calculatePayPalFee(calculateSubtotal() + calculateShipping())
    }
}

function addToCart() {
    // Get current item name
    let itemName = productDetails.querySelector('.name').innerText
    // Check if it matches a product
    let productFound = PRODUCTS.find(({ name }) => name === itemName) || PRODUCTS.find(({ nameFR }) => nameFR === itemName)
    if (!productFound) {
        showBanner('The product could not be found...', "Le produit n'existe pas...", 0)
        closeProductCard()
        return
    }

    // Check if product has sizes
    let selectedSize = null
    if (productFound.sizes) {
        // Check if selected size is valid
        selectedSize = productDetails.querySelector('input[type="radio"]:checked + .size').innerText
        if (!productFound.sizes.includes(selectedSize.toLowerCase())) {
            showBanner('The selected size could not be found...', "La taille sélectionnée n'existe pas...", 0)
            closeProductCard()
            return
        }
    }

    // Create a cart item object
    let item = {
        thumbnail: currentThumbnail.cloneNode(),
        name: `${itemName}${selectedSize ? ' - ' + selectedSize : ''}`,
        price: productFound.price,
        quantity: parseInt(productDetails.querySelector('.quantity').value),
        product: productFound,
    }
    // Check if the item is already in the cart
    let existingItem = null
    for (let entry of cart) {
        if (entry.name === item.name) {
            existingItem = entry
        }
    }

    if (existingItem) {
        // Add the quantity to the existing quantity (up to 9)
        existingItem.quantity = Math.min(existingItem.quantity + item.quantity, 9)
    } else {
        // Add the new item to the cart
        confirmItContent.classList.toggle('empty', false)
        sendItContent.classList.toggle('disabled', false)
        fieldset.disabled = false
        cart.push(item)
        // Clear the previous order ID and amount
        clearLocalStorage()
        orderID.value = ''
        orderAmount.value = ''
        disablePayPal()
    }

    // Resets the HTML elements in the confirm-it section
    updateCart()

    calculatePayPalFee(calculateSubtotal() + calculateShipping())

    showBanner('Item successfully added to cart!\xa0:) Scroll down for checkout', "Ajouté au panier!\xa0:) Défilez pour terminer l'achat")
    closeProductCard()
}

function updateCart() {
    // Reset cart
    cartContainer.innerHTML = ''

    // Loop through every item
    for (let i = 0; i < cart.length; i++) {
        let entry = cart[i]
        // Duplicate template HTML
        let newItem = cartItemTemplate.content.cloneNode(true)

        // Populate data fields
        let itemElement = newItem.querySelector('.item')
        itemElement.prepend(entry.thumbnail)
        newItem.querySelector('.name').innerText = entry.name
        newItem.querySelector('.price-tag').innerText = isFR ? entry.price + '$' : '$' + entry.price
        let newQuantity = newItem.querySelector('.quantity')
        newQuantity.value = entry.quantity

        // Link the cart item element with the item object in the cart array
        newQuantity.parentElement.cartItem = entry

        // Validate initial quantity
        let eObject = { target: newQuantity }
        validateQuantity(eObject)
        // Validate value on user input
        newQuantity.addEventListener('input', validateQuantity)

        // Listener to remove item
        let closeButton = newItem.querySelector('.remove-button')
        closeButton.addEventListener('click', removeFromCart)

        // Add item to cart
        cartContainer.appendChild(newItem)
    }
}

function removeFromCart() {
    // this => x button
    // this.parentElement => cart item element
    let parent = this.parentElement
    parent.querySelector('.quantity').removeEventListener('input', validateQuantity)
    this.removeEventListener('click', removeFromCart)

    // Fade out the cart item element
    gsap.to(parent, {
        opacity: 0,
        duration: 0.3,
        onComplete: () => {
            parent.remove()
            // Find the index of the item object in the cart array that corresponds to the current cart item element
            let removeIndex = cart.indexOf(parent.cartItem)
            cart.splice(removeIndex, 1)
            // Update subtotal and shipping
            calculatePayPalFee(calculateSubtotal() + calculateShipping())
            // Check if cart is now empty
            if (cart.length === 0) {
                confirmItContent.classList.toggle('empty', true)
                sendItContent.classList.toggle('disabled', true)
                fieldset.disabled = true
            }
        },
    })

    showBanner('Item removed from cart.', 'Retiré du panier.', 2)
}

function calculateSubtotal() {
    let totalSum = 0
    for (let entry of cart) {
        totalSum += entry.price * entry.quantity
    }
    // Update the subtotal in the confirm-it section
    cartTotal.value = isFR ? totalSum + '$' : '$' + totalSum
    return totalSum
}

function calculateShipping() {
    let newShippingFee = 0
    let maxShippingBase = 0
    for (let entry of cart) {
        newShippingFee += entry.product.shippingPerItem * entry.quantity
        maxShippingBase = Math.max(maxShippingBase, entry.product.shippingBase)
    }
    newShippingFee += maxShippingBase
    // Update the shipping fee in the send-it section
    shippingFee.innerText = `${isFR ? 'Livrer' : 'Ship it'}${
        newShippingFee === 0 ? '' : isFR ? ' (' + newShippingFee + '$)' : ' ($' + newShippingFee + ')'
    }`
    // Return 0 if client decided to pick up
    return shipIt.checked ? newShippingFee : 0
}

function calculatePayPalFee(amount) {
    // 2.9% + 0.30
    let newPayPalFee = 0.029 * amount + 0.3
    // Round to 1 decimal
    let roundedFloat = parseFloat(newPayPalFee.toFixed(1))
    // Round up to lower integer
    let newFee = Math.floor(roundedFloat)
    if (amount === 0) {
        newFee = 0
    }
    // Update the PayPal fee in the pay-it section
    paypalFeeElement.innerText = `${isFR ? 'OU' : 'OR'}${newFee ? (isFR ? ' (+' + newFee + '$)' : ' (+$' + newFee + ')') : ''}`
    return newFee
}
/* -------- END PRODUCTS & CART -------- */

/* -------- START CLIENT INFO -------- */
let finalOrderID = null
let finalOrderSubtotal = null
let finalOrderShipping = null
let finalOrderTotal = null
let finalPayPalFee = null
let purchase_units = null
let paypalButtonActions = null

pickUp.addEventListener('change', toggleLocation)
shipIt.addEventListener('change', toggleLocation)
// Change the form depending on user's delivery choice
function toggleLocation() {
    if (pickUp.checked) {
        pickupLocation.parentElement.style.display = 'flex'
        pickupLocation.required = true
        shippingAddress.style.display = 'none'
    } else {
        pickupLocation.parentElement.style.display = 'none'
        pickupLocation.removeAttribute('required')
        shippingAddress.style.display = 'initial'
    }
}

function scrollToPayIt() {
    // Scroll to pay-it section
    try {
        payItCircle.scrollIntoViewIfNeeded()
        payItCircle.scrollIntoView()
    } catch (error) {
        console.error(error)
    }
}

form.addEventListener('submit', (e) => {
    // Avoid double clicks
    submitButton.disabled = true
    e.preventDefault()

    // Check if every field is filled
    validateForm((errorMessage, errorMessageFR) => {
        if (errorMessage.length > 0) {
            submitButton.disabled = false
            showBanner(errorMessage, errorMessageFR, 0)
            return
        }

        // Generate an order ID and insert it in the pay-it section
        finalOrderID = generateOrderID()
        orderID.value = finalOrderID
        // Calculate the total and insert it in the pay-it section
        finalOrderSubtotal = calculateSubtotal()
        finalOrderShipping = calculateShipping()
        finalOrderTotal = finalOrderSubtotal + finalOrderShipping
        finalPayPalFee = calculatePayPalFee(finalOrderTotal)
        orderAmount.value = isFR ? finalOrderTotal + '$' : '$' + finalOrderTotal

        updateLocalStorage(finalOrderID, finalOrderSubtotal, finalOrderShipping)

        // Post the data to Google Forms
        fetch(ORDER_POST_URL, {
            method: 'POST',
            mode: 'no-cors',
            header: {
                'Content-Type': 'application/json',
            },
            body: getInputData(),
        })
            .then(() => {
                // Disable the confirm-it and the send-it sections
                confirmItContent.classList.toggle('disabled', true)
                sendItContent.classList.toggle('disabled', true)
                fieldset.disabled = true
                // Disable the product cards
                productViewCard.style.pointerEvents = 'none'
                submitButton.value = isFR ? 'Bien reçu! :)' : 'Order sent! :)'

                // Update stock
                // Loop through every item in cart
                for (let i = 0; i < cart.length; i++) {
                    let entry = cart[i]
                    if (!entry.product.stock || !entry.product.stock.writeID) continue
                    let qtyOrdered = entry.product.stock.multiplier ? entry.product.stock.multiplier * entry.quantity : entry.quantity
                    postStockUpdate(qtyOrdered, entry.product.stock.writeID)
                }

                // Enable pay-it section and PayPal buttons
                enablePayPal(finalOrderID, finalOrderSubtotal, finalOrderShipping, finalPayPalFee)

                showBanner('Your order was sent! Please scroll down to pay :)', 'Commande envoyée! Défilez pour payer :)')

                scrollToPayIt()
            })
            .catch((error) => {
                console.error(error)
                submitButton.disabled = false
                showBanner('An unexpected error occurred :(', 'Une erreur est survenue :(', 0)
            })
    })
})
function postStockUpdate(quantity, inputID) {
    // Post the data to Google Forms
    fetch(STOCK_POST_URL, {
        method: 'POST',
        mode: 'no-cors',
        header: {
            'Content-Type': 'application/json',
        },
        body: getStockData(quantity, inputID),
    })
}
function getStockData(quantity, inputID) {
    let dataToPost = new FormData()
    dataToPost.append(inputID, JSON.stringify(quantity))
    return dataToPost
}

// Returns an error string depending on the field that is missing
function validateForm(submitForm) {
    let errorMessage = ''
    let errorMessageFR = ''
    if (clientName.value.length < 4) {
        errorMessage = 'Please enter your full name.'
        errorMessageFR = 'Veuillez entrer votre nom complet.'
    }
    if (!validateEmail(clientEmail.value)) {
        errorMessage = 'Please enter a valid email address.'
        errorMessageFR = 'Veuillez entrer une adresse courriel valide.'
    }
    if (pickUp.checked) {
        if (!pickupLocation.value) {
            errorMessage = 'Please select a pickup location.'
            errorMessageFR = 'Veuillez sélectionner un lieu de ramassage.'
        }
    } else {
        if (clientAddress.value.length < 4) {
            errorMessage = 'Please enter your shipping address.'
            errorMessageFR = 'Veuillez entrer votre adresse de livraison.'
        }
        if (clientCity.value.length < 2) {
            errorMessage = 'Please enter your city.'
            errorMessageFR = 'Veuillez entrer la ville.'
        }
        if (clientProvince.value.length < 2) {
            errorMessage = 'Please enter your province.'
            errorMessageFR = 'Veuillez entrer la province.'
        }
        if (clientPostalCode.value.length < 6 || clientPostalCode.value.length > 7) {
            errorMessage = 'Please enter a valid postal code.'
            errorMessageFR = 'Veuillez entrer le code postal.'
        }
    }

    let toFetchCount = 0
    let fetchedCount = 0
    // Check how many need to be fetched
    for (let entry of cart) {
        if (entry.product.stock.readLink) {
            toFetchCount += 1
        }
    }
    for (let i = 0; i < cart.length; i++) {
        let entry = cart[i]

        // Send GET request to Google Sheets API
        if (entry.product.stock.readLink) {
            fetchStock(entry.product, (product, response) => {
                if (response.values) {
                    product.stock.quantity = parseInt(response.values[0][0])
                } else {
                    product.stock.quantity = 0
                }
                if (product.stock.quantity - (product.stock.multiplier ? product.stock.multiplier : 1) * entry.quantity < 0) {
                    errorMessage = "Sorry, we don't have enough spots left!"
                    errorMessageFR = 'Désolé, il ne reste plus assez de places!'
                }
                fetchedCount += 1
                if (fetchedCount === toFetchCount) {
                    submitForm(errorMessage, errorMessageFR)
                }
            })
        }
    }
    if (fetchedCount === toFetchCount) {
        submitForm(errorMessage, errorMessageFR)
    }
}

function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}

// The order ID is the 8 first characters of a hash of the current timestamp, the client's email and the elapsed time from page load
function generateOrderID() {
    let currentTime = Date.now()
    let clientEmailString = clientEmail.value
    let seasonedString = `${currentTime}${clientEmailString}${currentTime - startTime}`
    let hash = sha256(seasonedString)
    return `${hash.substring(0, 4)}-${hash.substring(4, 8)}`.toUpperCase()
}

// Get previous order ID and amount from cache
function retrieveFromLocalStorage() {
    let previousID = localStorage.getItem('previousID')
    let previousSubtotal = parseInt(localStorage.getItem('previousSubtotal'))
    let previousShipping = parseInt(localStorage.getItem('previousShipping'))
    let previousTotal = previousSubtotal + previousShipping
    let expiration = parseInt(localStorage.getItem('expiration'))

    // Check if it's valid and if the expiration has passed
    if (!previousID || !previousSubtotal || !expiration || expiration < Date.now()) {
        clearLocalStorage()
        return
    }
    orderID.value = previousID
    orderAmount.value = isFR ? previousTotal + '$' : '$' + previousTotal

    let previousPayPalFee = calculatePayPalFee(previousTotal)

    enablePayPal(previousID, previousSubtotal, previousShipping, previousPayPalFee)

    showBanner("Click here to pay for your order if you haven't done so already", 'Cliquez ici pour payer votre commande', 1, 10, scrollToPayIt)
}

// Saves the previous order details in the cache
function updateLocalStorage(newID, newSubtotal, newShipping) {
    clearLocalStorage()
    localStorage.setItem('previousID', newID)
    localStorage.setItem('previousSubtotal', newSubtotal)
    localStorage.setItem('previousShipping', newShipping)
    // Expiration is 24 hours from now (in milliseconds)
    localStorage.setItem('expiration', Date.now() + 86400000)
}

function clearLocalStorage() {
    localStorage.removeItem('previousID')
    localStorage.removeItem('previousSubtotal')
    localStorage.removeItem('previousShipping')
    localStorage.removeItem('expiration')
}

function getInputData() {
    let dataToPost = new FormData()

    dataToPost.append(ORDER_FORM.orderID, finalOrderID)
    dataToPost.append(ORDER_FORM.name, clientName.value)
    dataToPost.append(ORDER_FORM.email, clientEmail.value)
    dataToPost.append(ORDER_FORM.reminders, sendReminders.checked)

    // Remove the thumbnails, prices and products from the cart
    let cartClone = JSON.parse(JSON.stringify(cart))
    for (let entry of cartClone) {
        delete entry.thumbnail
        delete entry.price
        delete entry.product
    }

    // Add the subtotal, shipping fee and total to the order
    let orderData = {
        order: cartClone,
        subtotal: finalOrderSubtotal,
        shipping: finalOrderShipping,
        total: finalOrderTotal,
    }
    // Send the cart as the order
    dataToPost.append(ORDER_FORM.order, JSON.stringify(orderData))

    // Get pickup location or shipping address
    let deliveryLocation = pickupLocation.value
    if (shipIt.checked) {
        deliveryLocation = `${clientAddress.value}, ${clientCity.value}, ${clientProvince.value}, ${clientPostalCode.value}`
    }
    dataToPost.append(ORDER_FORM.delivery, deliveryLocation)

    dataToPost.append(ORDER_FORM.referrer, document.querySelector('#client-referrer').value)

    return dataToPost
}
/* -------- END CLIENT INFO -------- */

/* -------- PAYPAL -------- */
function disablePayPal() {
    // Disable the pay-it section
    payItContent.classList.toggle('disabled', true)
    purchase_units = null
    // Disable the PayPal buttons
    paypalButtonActions.disable()
    document.querySelector('#smart-button-container').style.zIndex = -1
}
function enablePayPal(paypalID, orderSubtotal, orderShipping, paypalFee) {
    // Enable the pay-it section
    payItContent.classList.toggle('disabled', false)
    // Create an order for PayPal
    purchase_units = [
        {
            description: `${isFR ? 'Commande' : 'Order'} ${paypalID} - ${isFR ? 'Boutique Coda' : 'Coda Shop'}`,
            invoice_id: paypalID,
            amount: {
                currency_code: 'CAD',
                value: orderSubtotal + orderShipping + paypalFee,
                breakdown: {
                    item_total: {
                        currency_code: 'CAD',
                        value: orderSubtotal + orderShipping + paypalFee,
                    },
                },
            },
            items: [
                {
                    name: `${isFR ? 'Sous-total' : 'Order Subtotal'}`,
                    unit_amount: {
                        currency_code: 'CAD',
                        value: orderSubtotal,
                    },
                    quantity: '1',
                },
                {
                    name: `${isFR ? 'Livraison' : 'Shipping'}`,
                    unit_amount: {
                        currency_code: 'CAD',
                        value: orderShipping,
                    },
                    quantity: '1',
                },
                {
                    name: `${isFR ? 'Frais PayPal' : 'PayPal Fee'}`,
                    unit_amount: {
                        currency_code: 'CAD',
                        value: paypalFee,
                    },
                    quantity: '1',
                },
            ],
        },
    ]
    // Enable the PayPal buttons and increase their z-index so they can be interacted with
    paypalButtonActions.enable()
    document.querySelector('#smart-button-container').style.zIndex = 1
}

// Builds the PayPal buttons
initPayPalButton()
function initPayPalButton() {
    paypal
        .Buttons({
            style: {
                color: 'blue',
                shape: 'pill',
                label: 'pay',
                layout: 'vertical',
                tagline: false,
            },
            // Disable the buttons and save to actions to later re-enable the buttons
            onInit: function (data, actions) {
                actions.disable()
                paypalButtonActions = actions
                // Get previous order ID and amount from cache
                retrieveFromLocalStorage()
            },
            // Create an order with the correct order ID and amount
            createOrder: function (data, actions) {
                return actions.order.create({
                    purchase_units: purchase_units,
                    application_context: {
                        shipping_preference: 'NO_SHIPPING',
                    },
                })
            },
            // Capture the transaction and show success message
            onApprove: function (data, actions) {
                return actions.order.capture().then(function (orderData) {
                    // Send the payment details
                    postPaymentDetails(orderData)
                    // Clear cache
                    clearLocalStorage()

                    // Show a success message within this page, e.g.
                    const element = document.querySelector('#paypal-button-container')
                    element.innerHTML = `<div class="paypal-success">${isFR ? 'Merci pour votre paiement' : 'Thank you for your payment'}!</div>`
                    showBanner('Your payment was received!', 'Nous avons reçu votre paiement!', 1, 10)
                })
            },
            onError: function (error) {
                showBanner('An unexpected error occured :(', 'Une erreur est survenue :(', 0)
                console.log(error)
            },
        })
        .render('#paypal-button-container')
}

function postPaymentDetails(data) {
    // Post the data to Google Forms
    fetch(PAYMENT_POST_URL, {
        method: 'POST',
        mode: 'no-cors',
        header: {
            'Content-Type': 'application/json',
        },
        body: getPaymentData(data),
    })
}

function getPaymentData(data) {
    let dataToPost = new FormData()
    dataToPost.append(PAYMENT_FORM, JSON.stringify(data))
    return dataToPost
}
/* -------- END PAYPAL -------- */
